const IconImage = ({ src, alt = "", size = 56 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 140 140"
      style={{
        display: "block",
        flexShrink: 0,
        maxWidth: size,
        maxHeight: size,
      }}
      role="img"
      aria-label={alt}
    >
      <defs>
        <clipPath id={`clip-${alt}`}>
          <rect x="4" y="4" width="132" height="132" rx="28" />
        </clipPath>
      </defs>

      {/* Background */}
      <rect x="4" y="4" width="132" height="132" rx="28" fill="#fff" />

      {/* Image */}
      <image
        href={src}
        x="14"
        y="14"
        width="112"
        height="112"
        preserveAspectRatio="xMidYMid meet"
        clipPath={`url(#clip-${alt})`}
      />

      {/* Inner border */}
      <rect
        x="10"
        y="10"
        width="120"
        height="120"
        rx="24"
        fill="none"
        stroke="rgba(0,0,0,0.08)"
        strokeWidth="2"
      />
    </svg>
  );
};

export default IconImage;